[
  {
    "code": "PK-JK",
    "name": "Azad Kashmir"
  },
  {
    "code": "PK-BA",
    "name": "Baluchistan"
  },
  {
    "code": "PK-TA",
    "name": "Federally Administered Tribal Areas"
  },
  {
    "code": "PK-IS",
    "name": "Islamabad"
  },
  {
    "code": "PK-NW",
    "name": "North-West Frontier"
  },
  {
    "code": "PK-NA",
    "name": "Northern Areas"
  },
  {
    "code": "PK-PB",
    "name": "Punjab"
  },
  {
    "code": "PK-SD",
    "name": "Sind"
  }
]